// extracted by mini-css-extract-plugin
export var addressFields = "_js-0";
export var animationContainer = "_js-1";
export var footer = "_js-2";
export var lineItems = "_js-3";
export var modalContent = "_js-4";
export var orderName = "_js-5";
export var strong = "_js-6";
export var warning = "_js-7";